(()=>{
  function qs(sel, root=document){ return root.querySelector(sel); }
  function qsa(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }

  function openDrawer() {
    const drawer = qs('[data-rw-search-drawer]');
    if (!drawer) return;
    drawer.hidden = false;
    const input = qs('[data-rw-search-input]', drawer);
    if (input) setTimeout(()=> input.focus(), 0);
  }
  function closeDrawer() {
    const drawer = qs('[data-rw-search-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
  }

  function bindSearch() {
    const trigger = qs('[data-rw-open-search]');
    const drawer = qs('[data-rw-search-drawer]');
    const flyout = qs('[data-rw-search-flyout]');
    // Attach the correct behavior
    if (drawer && trigger) {
      trigger.addEventListener('click', openDrawer);
      qsa('[data-rw-close-search]').forEach(btn => btn.addEventListener('click', closeDrawer));
    } else if (flyout && trigger) {
      let to;
      const show = () => {
        flyout.hidden = false;
        const fi = qs('[data-rw-search-input]', flyout);
        if (fi) setTimeout(()=> fi.focus(), 0);
      };
      const hide = () => { flyout.hidden = true; };
      const leaveLater = () => { clearTimeout(to); to = setTimeout(hide, 120); };
      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('focus', show);
      trigger.addEventListener('mouseleave', leaveLater);
      flyout.addEventListener('mouseenter', () => { clearTimeout(to); });
      flyout.addEventListener('mouseleave', leaveLater);
      document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') hide(); });
    }

    // Inline / flyout result hooks (first matching input/results on page)
    const input = qs('[data-rw-search-input]');
    const results = qs('[data-rw-search-results]');
    if (!input || !results) return;

    let lastQuery = '';
    let inflight = 0;
    async function fetchSuggest(q) {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&page=1&limit=4`;
      try {
        inflight++;
        const res = await fetch(url, { headers: { 'Accept': 'application/json' }});
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        return data;
      } finally {
        inflight = Math.max(0, inflight - 1);
      }
    }

    function renderResults(data, q) {
      const prods = (data?.resources?.results?.products) || [];
      const cols = (data?.resources?.results?.collections) || [];
      const colChips = (cols || []).slice(0,4).map(c => `<a class=\"rw-col-chip\" href=\"${c.url}\" aria-label=\"View collection ${c.title}\"><span>${c.title}</span></a>`);
      const items = [];
      prods.slice(0,8).forEach(p => {
        const price = p?.price ? ('$' + String(p.price).replace(/^\$?/, '')) : '';
        const img = p?.image || '';
        const imgHTML = img ? `<span class=\"rw-thumb rw-thumb--img\"><img src=\"${img}\" alt=\"\"></span>` : `<span class=\"rw-thumb\" aria-hidden=\"true\"></span>`;
        items.push(`<a class=\"rw-s-item rw-s-product\" href=\"${p.url}\" role=\"option\">${imgHTML}<span class=\"rw-s-title\">${p.title}</span>${price ? `<span class=\"rw-s-price\">${price}</span>` : ''}</a>`);
      });
      const chipsRow = colChips.length ? `<div class=\"rw-col-chips\">${colChips.join('')}</div>` : '';
      if (!items.length && !colChips.length) {
        results.innerHTML = `<div class=\"rw-ps-empty\">No results for “${q}”</div>`;
        results.classList.add('open');
        return;
      }
      results.innerHTML = `${chipsRow}<div class=\"rw-s-grid\">${items.join('')}</div><div class=\"rw-s-footer\"><a href=\"/search?q=${encodeURIComponent(q)}\">View all results</a></div>`;
      results.classList.add('open');
    }

    let t;
    input.addEventListener('input', () => {
      const q = input.value.trim();
      if (q === lastQuery) return;
      lastQuery = q;
      if (!q) { results.innerHTML = '<div class="rw-ps-empty">Start typing to search…</div>'; results.classList.remove('open'); return; }
      results.setAttribute('aria-busy', 'true');
      clearTimeout(t);
      t = setTimeout(async () => {
        try {
          const data = await fetchSuggest(q);
          renderResults(data, q);
        } catch(e) {
          results.innerHTML = `<div class="rw-ps-empty">Search unavailable. <a href="/search?q=${encodeURIComponent(q)}">Try full search</a></div>`;
          results.classList.add('open');
        } finally {
          results.setAttribute('aria-busy', 'false');
        }
      }, 200);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim()) results.classList.add('open');
    });

    document.addEventListener('click', (e) => {
      const isInside = e.target.closest('.rw-search');
      if (!isInside) results.classList.remove('open');
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { results.classList.remove('open'); closeDrawer(); }
    });
  }

  function bindMobileNav() {
    const openBtn = qs('[data-rw-open-mobile]');
    const drawer = qs('[data-rw-mobile-drawer]');
    const closeBtns = qsa('[data-rw-close-mobile]');
    if (!openBtn || !drawer) return;

    function open() {
      drawer.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }
    openBtn.addEventListener('click', open);
    closeBtns.forEach(b => b.addEventListener('click', close));
    drawer.addEventListener('click', (e) => {
      if (e.target && e.target.matches('.rw-mobile-backdrop')) close();
    });
  }

  function bindSticky() {
    const header = qs('.rw-header');
    if (!header) return;
    const onScroll = () => {
      if (window.scrollY > 10) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function bindMega() {
    const navbar = qs('.rw-navbar');
    if (!navbar) return;

    const items = qsa('.rw-nav-item.has-mega');
    if (!items.length) return;

    let currentMega = null;
    let hideTimer = null; // Single shared timer
    let showTimer = null; // Timer for delayed show (prevents accidental triggers)
    const SHOW_DELAY = 180; // ms delay before showing menu on hover

    // Position and show mega menu
    const showMega = (itemId) => {
      const mega = qs(`[data-mega-for="${itemId}"]`);
      if (!mega) return;

      // Clear any pending hide
      clearTimeout(hideTimer);

      // Hide current mega if different
      if (currentMega && currentMega !== mega) {
        currentMega.setAttribute('hidden', '');
      }

      // Position below navbar
      const navbarRect = navbar.getBoundingClientRect();
      mega.style.top = (navbarRect.bottom) + 'px';

      // Show mega
      mega.removeAttribute('hidden');
      currentMega = mega;
    };

    const hideMega = () => {
      if (currentMega) {
        currentMega.setAttribute('hidden', '');
        currentMega = null;
      }
    };

    const cancelShow = () => {
      clearTimeout(showTimer);
    };

    const scheduledHide = () => {
      cancelShow();
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideMega, 300);
    };

    // Bind hover events to nav items
    items.forEach((item) => {
      const itemId = item.getAttribute('data-nav-item');
      if (!itemId) return;

      item.addEventListener('mouseenter', () => {
        cancelShow();
        clearTimeout(hideTimer);
        // If a mega menu is already open, switch instantly (intent established)
        // Otherwise, use delay to prevent accidental triggers
        if (currentMega) {
          showMega(itemId);
        } else {
          showTimer = setTimeout(() => showMega(itemId), SHOW_DELAY);
        }
      });

      item.addEventListener('mouseleave', scheduledHide);
    });

    // Allow hovering over mega menu itself
    qsa('.rw-mega').forEach((mega) => {
      mega.addEventListener('mouseenter', () => {
        cancelShow();
        clearTimeout(hideTimer);
      });

      mega.addEventListener('mouseleave', scheduledHide);
    });

    // Update position on scroll
    let scrollTimer;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (currentMega) {
          const navbarRect = navbar.getBoundingClientRect();
          currentMega.style.top = (navbarRect.bottom) + 'px';
        }
      }, 10);
    }, { passive: true });
  }

  function bindNavRail() {
    const wrapper = qs('[data-rw-nav-wrapper]');
    if (!wrapper) return;

    const rail = qs('[data-rw-nav-rail]', wrapper);
    const leftArrow = qs('[data-rw-nav-arrow="left"]', wrapper);
    const rightArrow = qs('[data-rw-nav-arrow="right"]', wrapper);
    if (!rail || !leftArrow || !rightArrow) return;

    let currentTranslate = 0;
    const scrollStep = 300; // pixels to scroll per click

    function updateArrows() {
      const railWidth = rail.scrollWidth;
      const wrapperWidth = wrapper.offsetWidth;
      const maxTranslate = Math.max(0, railWidth - wrapperWidth);

      // Show/hide arrows based on scroll position
      if (currentTranslate <= 0) {
        leftArrow.classList.remove('visible');
      } else {
        leftArrow.classList.add('visible');
      }

      if (currentTranslate >= maxTranslate) {
        rightArrow.classList.remove('visible');
      } else {
        rightArrow.classList.add('visible');
      }
    }

    function scrollLeft() {
      currentTranslate = Math.max(0, currentTranslate - scrollStep);
      rail.style.transform = `translate(${-currentTranslate}px, 0px)`;
      updateArrows();
    }

    function scrollRight() {
      const maxTranslate = Math.max(0, rail.scrollWidth - wrapper.offsetWidth);
      currentTranslate = Math.min(maxTranslate, currentTranslate + scrollStep);
      rail.style.transform = `translate(${-currentTranslate}px, 0px)`;
      updateArrows();
    }

    leftArrow.addEventListener('click', scrollLeft);
    rightArrow.addEventListener('click', scrollRight);

    // Initial check
    updateArrows();

    // Update on window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        currentTranslate = 0;
        rail.style.transform = 'translate(0px, 0px)';
        updateArrows();
      }, 150);
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', bindSearch);
  document.addEventListener('DOMContentLoaded', bindMobileNav);
  document.addEventListener('DOMContentLoaded', bindSticky);
  document.addEventListener('DOMContentLoaded', bindMega);
  document.addEventListener('DOMContentLoaded', bindNavRail);
})();

/* Collapsible mobile sub-menus */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-rw-mnav-toggle]');
  if (!btn) return;
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', !expanded);
  var sub = btn.parentElement.querySelector('.rw-mnav-sub');
  if (sub) sub.hidden = expanded;
});
